module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-bronze.8e89c5d9.png";